import React from "react";

const ArrowLeftIcon = ({ fill = "#fff", PathClassName = "", ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.125"
      height="13.5"
      viewBox="0 0 19.125 13.5"
      {...rest}
    >
      <g id="md-log-in" transform="translate(22.5 24.75) rotate(180)">
        <path
          id="Path_3"
          data-name="Path 3"
          d="M3.375,19.5H16.713l-3.066,3.143,2.1,2.1L22.5,18l-6.75-6.75-2.18,2.1L16.713,16.5H3.375V19.5Z"
          fill={fill}
          className={PathClassName}
        />
      </g>
    </svg>
  );
};

export default ArrowLeftIcon;
